import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Check } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export function WhatYouGet() {
  const features = ['+400 recetas', 'técnicas de barista', 'métodos de preparación', 'cultura cafetera'];
  return <section className="py-16 md:py-24 px-4" data-id="element-175">
      <div className="max-w-5xl mx-auto" data-id="element-176">
        <div className="text-center mb-16" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-bold text-espresso-900 mb-4" data-id="element-178">
            DESCARGA HOY Y RECIBE CON TU COMPRA
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-179"></div>
        </div>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-espresso-900/10" data-id="element-180">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-181">
            {/* Image Side */}
            <div className="bg-cream-200 p-12 flex items-center justify-center relative overflow-hidden" data-id="element-182">
              <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-espresso-900 to-transparent" data-id="element-183"></div>
              <motion.div whileHover={{
              scale: 1.02,
              rotate: -2
            }} className="relative bg-espresso-900 w-full max-w-sm aspect-[3/4] rounded-r-2xl rounded-l-md shadow-2xl flex flex-col items-center justify-center p-8 text-cream-100 border-l-8 border-gold-600" data-id="element-184">
                <BookOpen className="w-16 h-16 text-gold-500 mb-6" data-id="element-185" />
                <h3 className="font-serif text-3xl font-bold text-center mb-2" data-id="element-186">
                  LA BIBLIA DEL CAFÉ
                </h3>
                <p className="text-gold-500 text-sm tracking-widest uppercase" data-id="element-187">
                  Edición Premium
                </p>
              </motion.div>
            </div>

            {/* Content Side */}
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-188">
              <h3 className="text-2xl md:text-3xl font-bold text-espresso-900 mb-4" data-id="element-189">
                La guía definitiva para aprender a preparar café profesional en
                casa.
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 my-8" data-id="element-190">
                {features.map((feature, idx) => <div key={idx} className="flex items-center gap-3 bg-cream-100 p-3 rounded-lg border border-espresso-900/5" data-id="element-191">
                    <Check className="w-5 h-5 text-cta-600" data-id="element-192" />
                    <span className="font-medium text-espresso-800" data-id="element-193">
                      {feature}
                    </span>
                  </div>)}
              </div>

              <div className="bg-cream-100 p-6 rounded-xl border border-gold-500/30 text-center mb-8" data-id="element-194">
                <p className="text-sm font-bold text-espresso-700 uppercase tracking-wider mb-2" data-id="element-195">
                  Oferta Especial
                </p>
                <div className="flex justify-center" data-id="element-196">
                  <PriceDisplay amount={13.97} originalAmount={30} size="lg" data-id="element-197" />
                </div>
              </div>

              <a href="https://elartedelcafe.online/cart/add?id=57377971798341&quantity=1" className="w-full bg-cta-600 hover:bg-cta-800 text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all text-center flex items-center justify-center gap-2" data-id="element-198">
                <span className="text-2xl" data-id="element-199">🟢</span> Agregar al carrito
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}